const compareModules = document.querySelectorAll('.compare-module');
const compareModuleContents = document.querySelectorAll('.compare-module__content');
const smallScreen = 640;

if (compareModules) {
    [].forEach.call(compareModules, compareModule => {
        const tabLinks = compareModule.querySelectorAll('.compare-module__header');
        const moduleContents = compareModule.querySelectorAll('.compare-module__content');

        [].forEach.call(tabLinks, tabLink => {
            tabLink.addEventListener('click', (e) => {
                e.preventDefault();
                handleTabLinkClick(tabLinks, tabLink, moduleContents);
            });
        })
    });
}

handleTabLinkClick = (tabLinks, tabLink, moduleContents) => {
    const contentId = tabLink.dataset.id;

    [].forEach.call(tabLinks, tabLink => {
        tabLink.classList.remove('active');
    });
    [].forEach.call(moduleContents, moduleContent => {
        moduleContent.classList.remove('active');
        if (moduleContent.id === contentId) {
            moduleContent.classList.add('active');
        }
    });
    tabLink.classList.add('active');
};

addCompareContentPaddingOnMobile = (isSmall) => {
    let compareModulesCtaHeight;

    [].forEach.call(compareModules, compareModule => {
        compareModulesCtaHeight = compareModule.querySelector('.compare-module__cta').clientHeight;
    });

    if (isSmall) {
        [].forEach.call(compareModuleContents, moduleContent => {
            moduleContent.style.paddingBottom = `${compareModulesCtaHeight + 48}px`
        });
    } else {
        [].forEach.call(compareModuleContents, moduleContent => {
            moduleContent.removeAttribute('style');
        });
    }
};

window.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth < smallScreen) {
        addCompareContentPaddingOnMobile(true);
    } else {
        addCompareContentPaddingOnMobile(false);
    }
});

window.addEventListener('resize', () => {
    if (window.innerWidth < smallScreen) {
        addCompareContentPaddingOnMobile(true);
    } else {
        addCompareContentPaddingOnMobile(false);
    }
});
